const costCenterServiceName = "/CostCenter";

export function costCenterService(http) {
  return {
    getAllCostCentersConditionallyAsync: async (pageNumber, pageSize, sortBy, filters) => {
      const newSort = (sortBy || []).map(item => ({
          member: item.id,
          sortDirection: item.desc ? "Descending" : "Ascending"
      }));
      const filter=filters;
      const data = {
          dataAttribute:{
              page:pageNumber,
              pageSize,
              sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
              filter: filter
          }
      }
      return await http.post(costCenterServiceName + '/GetAllCostCentersConditionallyAsync', data);
    },
    getAllPagedCostCenterActivities: async (pageNumber, pageSize, sortBy, filters, costCenterCode, costCenterOmit) => {
      const newSort = (sortBy || []).map(item => ({
          member: item.id,
          sortDirection: item.desc ? "Descending" : "Ascending"
      }));
      const filter=filters;

      const data = {
        dataAttribute:{
              page:pageNumber,
              pageSize,
              sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
              filter: filter
          },
          activity: {
            costCenterCode,
          }
      }

      return await http.post(costCenterServiceName + '/GetAllPagedCostCenterActivities', data);
    },
    downloadFilteredCostCenterActivities:async (parameters) => {
      return await http.post(costCenterServiceName + '/DownloadFilteredCostCenterActivities', parameters,{ responseType: "blob" });
    },
    // downloadFilteredCostCenterActivities:async (sortBy, filters, costCenterCode) => {
    //   debugger;
    //   const newSort = (sortBy || []).map(item => ({
    //       member: item.id,
    //       sortDirection: item.desc ? "Descending" : "Ascending"
    //   }));
    //   const filter=filters;

    //   const data = {
    //     dataAttribute:{
    //           page:1,
    //           pageSize: 1,
    //           sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
    //           filter: filter
    //       },
    //       activity: {
    //         costCenterCode,
    //       }
    //   }
      

    //   return await http.post(costCenterServiceName + '/DownloadFilteredCostCenterActivities', data);
    // },        
    getAllCostCenterActivities: async (costCenterCode, costCenterOmit) => {
      const parameters = {
        code: costCenterCode,
        isOmit: costCenterOmit
      }

      return await http.post(costCenterServiceName + '/GetAllCostCenterActivities', parameters);
    },

    getAllCostCenters: () => {
      return http.get(costCenterServiceName + "/GetAllCostCenter");
    },
    getAllActivitiess: () => {
      return http.get(costCenterServiceName + "/GetAllCostCenter");
    },
    getTotalCostCenters: () => {
      return http.get(costCenterServiceName + "/GetTotalCostCenters");
    },    
    getUserCostCenters: (userId) => {
      let seenRequest = {
        userId,
      };
      return http.post(
        costCenterServiceName + "/GetUserCostCenters",
        seenRequest
      );
    },
    GetProjectOrDisciplines: () => {
      return http.get(costCenterServiceName + "/GetProjectOrDisciplines");
    },
    getAllCostCenterTypes: () => {
      return http.get(costCenterServiceName + "/GetAllCostCenterTypes");
    },
    getAllAvailableCodes: () => {
      return http.get(costCenterServiceName + "/GetAllAvailableCodes");
    },
    getAllUnTakenCostCenterCodes: () => {
      return http.get(costCenterServiceName + "/GetAllUnTakenCostCenterCodes");
    },
    getAllTemporaryReservedNewCostCenterCodes: () => {
      return http.get(
        costCenterServiceName + "/GetAllTemporaryReservedNewCostCenterCodes"
      );
    },
    setTemporaryReservedNewCostCenterCode: (userId, type, code) => {
      let parameters = {
        userId,
        costCenterCode: code,
        type: type,
      };
      return http.post(
        costCenterServiceName + "/SetTemporaryReservedNewCostCenterCode",
        parameters
      );
    },
    deleteTemporaryReservedNewCostCenterCode: (userId, type, code) => {
      let parameters = {
        userId,
        costCenterCode: code,
        type: type,
      };
      return http.post(
        costCenterServiceName + "/DeleteTemporaryReservedNewCostCenterCode",
        parameters
      );
    },

    deleteAllUserReservedCostCenterCode: (userId) => {
      let parameters = {
        userId,
      };

      return http.post(
        costCenterServiceName + "/DeleteAllUserReservedCostCenterCode",
        parameters
      );
    },

    getDomesticProjectOwner: () => {
      return http.get(costCenterServiceName + "/GetDomesticProjectOwner");
    },
    getAllIsSurrogateCostCenters: () => {
      return http.get(costCenterServiceName + "/GetAllIsSurrogateCostCenters");
    },
    getAvailableCostCenterCode: (type, codePosition, steps) => {
      let parameters = {
        type,
        codePosition,
        steps,
      };
      return http.post(
        costCenterServiceName + "/GetAvailableCostCenterCode",
        parameters
      );
    },
    getMaxCostCenterCode: () => {
      return http.get(costCenterServiceName + "/GetMaxCostCenterCode");
    },
    saveNewCostCenterCodeAsync: async (
      projectType,
      costCenterCode,
      projectOrDisciplineCode,
      farsiDescription,
      latinDescription,
      isCostCenterSection,
      finishedProject,
      surrogation,
      costCenterType,
      domesticProjectOwner,
      surrogateCostCenter,
      costCenterAbbrivation,
      costCenterUnique,
      orderdRow,
      suggestedBuddget,
      jobPlacement,
      isSurrogate,
      isActive
    ) => {
      let parameters = {
        projectType: projectType.selected.value,
        costCenterCode: costCenterCode,
        projectOrDisciplineCode: projectOrDisciplineCode.value.trim(),
        farsiDescription: farsiDescription.value.trim(),
        latinDescription: latinDescription.value.trim(),
        isCostCenterSection:  isCostCenterSection.value,
        isSurrogate:  isSurrogate.value,
        finishedProject : finishedProject.value,
        surrogation: surrogation.value.trim(),
        isActive: isActive.value.trim(),
        costCenterType: costCenterType.selected.value,
        domesticProjectOwner: domesticProjectOwner.selected.value,
        ownerDirector: surrogateCostCenter.selected.value,
        costCenterAbbrivation: costCenterAbbrivation.value.trim(),
        costCenterUnique: costCenterUnique.value.trim(),
        orderdRow: parseInt(orderdRow.value),
        suggestedBuddget: parseInt(suggestedBuddget.value),
        jobPlacement: parseInt(jobPlacement.value),
      };

      return await http.post(costCenterServiceName + "/SaveNewCostCenterCodeAsync", parameters);
    },
    updateExistingCostCenterCodeAsync: async (
      projectType,
      costCenterCode,
      projectOrDisciplineCode,
      farsiDescription,
      latinDescription,
      isCostCenterSection,
      finishedProject,
      costCenterSurrogate,
      surrogation,
      costCenterType,
      domesticProjectOwner,
      surrogateCostCenter,
      costCenterAbbrivation,
      costCenterUnique,
      orderdRow,
      suggestedBuddget,
      jobPlacement,
      isSurrogate,
      isActive
    ) => {
      let parameters = {
        projectType: projectType.selected.value,
        costCenterCode: costCenterCode,
        projectOrDisciplineCode: projectOrDisciplineCode.value,
        farsiDescription: farsiDescription.value,
        latinDescription: latinDescription.value,
        isCostCenterSection:  isCostCenterSection.value,
        isSurrogate:  isSurrogate.value,
        finishedProject : finishedProject.value,
        costCenterSurrogate: costCenterSurrogate.value,
        surrogation: surrogation.value,
        isActive: isActive.value,
        costCenterType: costCenterType.selected.value,
        domesticProjectOwner: domesticProjectOwner.selected.value,
        ownerDirector: surrogateCostCenter.selected.value,
        costCenterAbbrivation: costCenterAbbrivation.value,
        costCenterUnique: costCenterUnique.value,
        orderdRow: parseInt(orderdRow.value),
        suggestedBuddget: parseInt(suggestedBuddget.value),
        jobPlacement: parseInt(jobPlacement.value),
      };
      return await http.post(costCenterServiceName + "/UpdateExistingCostCenterCodeAsync", parameters);
    },    
  };
}
